import { createContext, useContext, useState, useEffect } from 'react';

import { fetchPosts } from '../../../../api/services/posts';
import { getMunis } from '../../../../api/services/main';
import { fetchHistoric, fetchPulp, fetchTimber } from '../../../../api/services/prices';

const WoodpricesContext = createContext();

export const WoodpricesProvider = ({ children }) => {
  const [sawtimberData, setSawtimberData] = useState({prices: [], highest: 0});
  const [sawtimberOptions, setsawtimberOptions] = useState({tree: 'tall', size: 'normal', quality: 'two'});

  const [pulpwoodData, setPulpwoodData] = useState({prices: [], highest: 0});
  const [pulpwoodOptions, setPulpwoodOptions] = useState({tree: 'tall', quality: 'one'});

  const [historicData, setHistoricData] = useState([]);
  const [historicOptions, setHistoricOptions] = useState({tree: 'tall', timeframe: '3y'});

  const [podcasts, setPodcasts] = useState([]);
  const [posts, setPosts] = useState([]);

  const [muni, setMuni] = useState('');
  const [munis, setMunis] = useState([]);

  const ONE_DAY_MS = 24 * 60 * 60 * 1000;

  useEffect(() => {
    if(!munis.length) {
      const munisStorage = localStorage.getItem('munis')
      if(munisStorage) {
        const JsonMunis = JSON.parse(munisStorage)
        setMunis(JsonMunis)
      } else {
        fetchMunis()
      }
    }

    const muniStorage = localStorage.getItem('woodprices_muni');
    if(muniStorage) {
      setMuni(muniStorage)
    }

    if(!podcasts.length) {
      fetchPodcasts()
    }

    if(!posts.length) {
      fetchNews()
    }
  }, [])

  useEffect(() => {
    if(muni) {
      localStorage.setItem('woodprices_muni', muni)
      fetchSawtimberPrices()
      fetchPulpwoodPrices()
      fetchHistoricPrices()
    }
  }, [muni])

  useEffect(() => {
    if(sawtimberOptions.tree == 'gran' && (sawtimberOptions.quality == 'three' || sawtimberOptions.quality == 'four')) {
      setsawtimberOptions(prev => ({...prev, quality: 'one'}))
    }
  }, [sawtimberOptions])

  const fetchMunis = async () => {
    const resp = await getMunis()

    if(resp.ok) {
      setMunis(resp.data.munis)
      localStorage.setItem('munis', JSON.stringify(resp.data.munis))
    } else {
      setMunis(null)
    }
  }

  const checkStorage = (name) => {
    const now = new Date().getTime();
    const storage = localStorage.getItem(name);
    if(storage) {
      const JsonStorage = JSON.parse(storage)
      if(now > JsonStorage.expiresAt || (!muni || muni != JsonStorage.muni)) {
        localStorage.removeItem(name);
        return false
      } else {
        return JsonStorage.data
      }
    } else {
      return false
    }
  }

  const fetchSawtimberPrices = async () => {
    setSawtimberData([])

    const sawtimberStorage = checkStorage('woodprices_sawtimber')
    if(sawtimberStorage) {
      setSawtimberData(sawtimberStorage)
    } else {
      const resp = await fetchTimber({muni: muni})

      if(!resp.ok) {
        setSawtimberData(null)
      } else {
        if(resp.data.prices.length) {
          const now = new Date().getTime()
          const storageData = {
            data: resp.data,
            muni: muni,
            expiresAt: now + ONE_DAY_MS
          }
          localStorage.setItem('woodprices_sawtimber', JSON.stringify(storageData))

          setSawtimberData(resp.data)
        } else {
          setSawtimberData(null)
        }
      }
    }
  }

  const fetchPulpwoodPrices = async () => {
    setPulpwoodData([])

    const pulpwoodStorage = checkStorage('woodprices_pulpwood')
    if(pulpwoodStorage) {
      setPulpwoodData(pulpwoodStorage)
    } else {
      const resp = await fetchPulp({muni: muni})

      if(!resp.ok) {
        setPulpwoodData(null)
      } else {
        if(resp.data.prices.length) {
          const now = new Date().getTime()
          const storageData = {
            data: resp.data,
            muni: muni,
            expiresAt: now + ONE_DAY_MS
          }
          localStorage.setItem('woodprices_pulpwood', JSON.stringify(storageData))

          setPulpwoodData(resp.data)
        } else {
          setPulpwoodData(null)
        }
      }
    }
  }

  const fetchHistoricPrices = async () => {
    setHistoricData([])

    const historicStorage = checkStorage('woodprices_historic')
    if(historicStorage) {
      setHistoricData(historicStorage)
    } else {
      const resp = await fetchHistoric({muni: muni})

      if(!resp.ok) {
        setHistoricData(null)
      } else {
        if(resp.data.length) {
          const now = new Date().getTime()
          const storageData = {
            data: resp.data,
            muni: muni,
            expiresAt: now + ONE_DAY_MS
          }
          localStorage.setItem('woodprices_historic', JSON.stringify(storageData))

          setHistoricData(resp.data)
        } else if(resp.data.error == 'not_plus_user') {
          setHistoricData(resp.data.error)
        } else {
          setHistoricData(null)
        }
      }
    }
  }

  const fetchPodcasts = async () => {
    setPodcasts([])

    const podcastsStorage = checkStorage('woodprices_podcasts')
    if(podcastsStorage) {
      setPodcasts(podcastsStorage)
    } else {
      const respData = {pagesize: 5, pageNr: 1, category: 'Treebula Studio'}
      const resp = await fetchPosts(respData)

      if(!resp.ok) {
        setPodcasts(null)
      } else {
        if(resp.data.posts.length) {
          const now = new Date().getTime()
          const storageData = {
            data: resp.data.posts,
            expiresAt: now + ONE_DAY_MS
          }
          localStorage.setItem('woodprices_podcasts', JSON.stringify(storageData))

          setPodcasts(resp.data.posts)
        } else {
          setPodcasts(null)
        }
      }
    }
  }

  const fetchNews = async () => {
    setPosts([])

    const postsStorage = checkStorage('woodprices_posts')
    if(postsStorage) {
      setPosts(postsStorage)
    } else {
      const resp = await fetchPosts({
        category: 'Allt',
        pagesize: 3,
        pageNr: 1,
      })

      if (!resp.ok) {
        setPosts(null)
      } else {
        const posts = resp.data?.posts ?? []
        if (posts.length) {
          const now = new Date().getTime()
          const storageData = {
            data: posts,
            expiresAt: now + ONE_DAY_MS
          }
          localStorage.setItem('woodprices_posts', JSON.stringify(storageData))
          setPosts(posts)
        } else {
          setPosts(null)
        }
      }
    }
  }

  return (
    <WoodpricesContext.Provider value={{sawtimberData, sawtimberOptions, setsawtimberOptions, fetchSawtimberPrices, pulpwoodData, pulpwoodOptions, setPulpwoodOptions, fetchPulpwoodPrices, historicData, historicOptions, setHistoricOptions, fetchHistoricPrices, podcasts, posts, fetchNews, fetchPodcasts, muni, setMuni, munis}}>
      {children}
    </WoodpricesContext.Provider>
  )
}

export const useWoodprices = () => useContext(WoodpricesContext);

export default WoodpricesContext;
